import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { BLOCKS } from '@contentful/rich-text-types';
import { readableColor } from 'polished';

import SectionContainer from './SectionContainer';
import Banner from './Banner';
import RichText from './RichTextV2';

const Section = styled.section`
  background-color: ${({ background }) => themeGet(`colors.${background}`)};
  color: ${({ theme, background }) => readableColor(
    theme.colors[background],
    theme.colors.black,
    theme.colors.black,
  )};
  padding: 40px 0 0;

  &:first-of-type {
    padding: 60px 0 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 60px 0 0;

    &:first-of-type {
      padding: 80px 0 0;
    }
  }
`;

const Heading = styled.h2`
  font-family: ${themeGet('typography.mobile.heading1.fontFamily')};
  font-weight: ${themeGet('typography.mobile.heading2.fontWeight')};
  font-size: ${themeGet('typography.mobile.heading2.fontSize')};
  line-height: ${themeGet('typography.mobile.heading2.lineHeight')};
  letter-spacing: ${themeGet('typography.mobile.heading2.letterSpacing')};
  text-align: center;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: ${themeGet('typography.desktop.heading2.fontSize')};
    line-height: ${themeGet('typography.desktop.heading2.lineHeight')};
  }
`;

const BannerContentOptions = {
  renderNode: {
    [BLOCKS.HEADING_1]: (_, children) => <Heading>{children}</Heading>,
    [BLOCKS.HEADING_2]: (_, children) => <Heading>{children}</Heading>,
  },
};

const BannerContent = ({ data }) => {
  if (!data) return null;
  const {
    sectionId,
    backgroundColor,
    sectionTitle,
    combinatorSectionItems,
  } = data;

  return (
    <Section id={sectionId} background={backgroundColor}>
      <SectionContainer>
        <RichText document={sectionTitle} options={BannerContentOptions} />
      </SectionContainer>
      {combinatorSectionItems.map((banner, index) => (
        <Banner key={banner.id} data={banner} isEven={!(index % 2)} />
      ))}
    </Section>
  );
};

BannerContent.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default BannerContent;
